/*
    [pageName]: [

    ]
*/

import { ConstructionOutlined } from "@mui/icons-material";
import { PATHS } from "Utils/PagePaths";
import { getPublicPageNameFromPath } from "Utils/utilityFunctions";



export const getPathCrumbs = (path) => {
    //console.log(path);
    var publicName = getPublicPageNameFromPath(path);
    //console.log(publicName);
    const segments = path.split('/').filter(segment => segment !== '');
    //console.log(segments);

    if (publicName == null) {
        return [];
    }
    if (publicName == 'Sign In' || publicName == 'Homepage') {
        return [];
    }

    var homeSegment = {
        name: 'Home',
        path: PATHS.public.Homepage
    };

    if (segments != null && segments.length < 1) {
        //console.log("Less than 1");
        return [
            homeSegment
        ];
    }
    else if (segments != null && segments.length == 1) {
        //console.log("Only 1");
        return [
            homeSegment,
            {
                name: publicName,
                path: PATHS.public[publicName]
            }
        ]
    }
    else {
        //console.log("More than 1");
        var arr = [
            homeSegment
        ];
        var tempPath = "";
        for (var x = 0; x < segments.length; x++) {
            //console.log(segments[x]);
            tempPath = tempPath + "/" + segments[x];
            var name = getPublicPageNameFromPath(tempPath);
            arr.push({
                name: name,
                path: PATHS.public[name]
            });
        }
        //console.log(arr);
        return arr;
    }

}

export const BREADCRUMBS = {
    "Homepage": null,
    "Sign In": null,

    "Become a PSO": {
        path: PATHS.public["Become a PSO"]
    },
    "User Account Types": {
        path: PATHS.public["User Account Types"]
    },

    "Use Common Formats": {
        path: PATHS.public["Use Common Formats"]
    },
    "Explore Common Format Data Elements": {
        path: PATHS.public["Explore Common Format Data Elements"]
    },
    "Data Element Detail": {
        path: PATHS.public["Data Element Detail"]
    },
    "Retired Common Formats": {
        path: PATHS.public["Retired Common Formats"]
    },
    "Community Pharmacy": {
        path: PATHS.public["Community Pharmacy"]
    },
    "Diagnostic Safety": {
        path: PATHS.public["Diagnostic Safety"]
    },
    "Hospital Version 1.2": {
        path: PATHS.public["Hospital Version 1.2"]
    },
    "Hospital Version 2.0": {
        path: PATHS.public["Hospital Version 2.0"]
    },
    "Nursing Home": {
        path: PATHS.public["Nursing Home"]
    },
    "Surveillance - Hospital": {
        path: PATHS.public["Surveillance - Hospital"]
    },

    "Submit Data": {
        path: PATHS.public["Submit Data"]
    },
    "Learn from the Data": {
        path: PATHS.public["Learn from the Data"]
    },
    "Get Help": {
        path: PATHS.public["Get Help"]
    },
    "About PSOPPC": {
        path: PATHS.public["About PSOPPC"]
    },
    "Search": {
        path: PATHS.public.Search
    },
    "Data Security": {
        path: PATHS.public["Data Security"]
    },
    "External Link Disclaimer": {
        path: PATHS.public["External Link Disclaimer"]
    },
    "Terms of Use": {
        path: PATHS.public["Terms of Use"]
    },
    "Accessibility": {
        path: PATHS.public.Accessibility
    },
    "Site Map": {
        path: PATHS.public["Site Map"]
    },
    "Privacy Policy": {
        path: PATHS.public["Privacy Policy"]
    },
    "Educational Briefs": {
        path: PATHS.public["Educational Briefs"]
    },
}